// extracted by mini-css-extract-plugin
export default {"globeIcon":"styleModule_globeIcon__pyJgN","drawerBodyContainer":"styleModule_drawerBodyContainer__wycQI"};